import { defaultMasteryLabels, isScreenshotMode } from "@constants/common";
import { useAppStore } from "@hooks/useAppStore";
import type { AppTheme } from "@hooks/useAppTheme";
import type { ScoreRange } from "@memorang/ui/types";

const getMasteryLabels = () => {
	const masteryLabels = useAppStore.getState().app?.masteryLabels;
	return masteryLabels || defaultMasteryLabels;
};

export const getProgressColorScale = (
	score: number,
	theme: AppTheme,
	scoreRanges: ScoreRange[],
) => {
	const { high, low, none: empty, medium } = theme.colors.progress;
	const lowScoreRange = scoreRanges[0].rangeArray[1];
	const mediumScoreRange = scoreRanges[1].rangeArray[1];

	if (isScreenshotMode) {
		return [high, empty];
	}
	if (score <= lowScoreRange) {
		return [low, empty];
	}
	if (score <= mediumScoreRange) {
		return [medium, empty];
	}
	return [high, empty];
};
export { getMasteryLabels };
